import assets from '@Apis/assets.api';

export const getAssetsByIdStartsWith = (searchById: string) => {
	return assets.get('/assets', { params: { searchById } });
};
export const getAssets = () => {
	return assets.get('/assets');
};
export const generateTilesForSystemType = (systemType: string) => {
	return assets.get(`/v2/tileset/generate?systemType=${systemType}`);
};
